import React from 'react'

const CloneIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 36 36'
  >
    <path
      fill='currentColor' d='M24 10V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4V12a2 2 0 0 1 2-2Z' className='clr-i-solid clr-i-solid-path-1'
    />
    <path
      fill='currentColor' d='M30 12H14a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2m-2 11h-5v5h-2v-5h-5v-2h5v-5h2v5h5Z' className='clr-i-solid clr-i-solid-path-2'
    />
    <path
      fill='none' d='M0 0h36v36H0z'
    />
  </svg>

)

export { CloneIcon }
